/* =========================================================================
   BY MINELLA — theme.js
   Global UI: slide-in menu, scroll lock, testimonials slider, FAQ accordion,
   sticky buy bar. (Cart drawer/AJAX lives in cart.js.)
   ========================================================================= */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  window.BMScrollLock = window.BMScrollLock || {
    _n: 0,
    on: function () { this._n++; document.body.style.overflow = 'hidden'; },
    off: function () { this._n = Math.max(0, this._n - 1); if (this._n === 0) document.body.style.overflow = ''; }
  };

  /* ---------- Slide-in navigation menu ---------- */
  var BMMenu = (function () {
    var lastFocus = null;
    function el() { return $('[data-bm-menu]'); }
    function open() {
      var m = el(); if (!m) return;
      lastFocus = document.activeElement;
      m.classList.add('is-open');
      var opener = $('[data-bm-menu-open]');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      window.BMScrollLock.on();
      var first = m.querySelector('.bm-menu__link, [data-bm-menu-close]');
      if (first) first.focus();
    }
    function close() {
      var m = el(); if (!m || !m.classList.contains('is-open')) return;
      m.classList.remove('is-open');
      var opener = $('[data-bm-menu-open]');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      window.BMScrollLock.off();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    return { open: open, close: close };
  })();
  window.BMMenu = BMMenu;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bm-menu-open]')) { e.preventDefault(); BMMenu.open(); return; }
    if (e.target.closest('[data-bm-menu-close]')) { e.preventDefault(); BMMenu.close(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') BMMenu.close();
  });

  // Scroll-to-top buttons (e.g. product final CTA)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-scroll-top]')) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  /* ---------- Testimonials / horizontal sliders ---------- */
  function initSliders() {
    $all('[data-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-slider-track]');
      if (!track) return;
      function step() {
        var card = track.querySelector(':scope > *');
        if (!card) return 320;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16') || 16;
        return card.getBoundingClientRect().width + gap;
      }
      slider.addEventListener('click', function (e) {
        if (e.target.closest('[data-slider-prev]')) track.scrollBy({ left: -step(), behavior: 'smooth' });
        if (e.target.closest('[data-slider-next]')) track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });
  }

  /* ---------- FAQ accordion: single-open per group ---------- */
  function initAccordions() {
    $all('[data-accordion]').forEach(function (group) {
      group.addEventListener('toggle', function (e) {
        var item = e.target;
        if (item.tagName !== 'DETAILS' || !item.open) return;
        $all('details[open]', group).forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }, true);
    });
  }

  /* ---------- Sticky buy bar ---------- */
  function initStickyBuy() {
    var bar = $('[data-sticky-buy]');
    var anchor = $('[data-buybar-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // show the bar once the main buy button has scrolled above the viewport
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
    }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
    obs.observe(anchor);
  }

  function init() {
    initSliders();
    initAccordions();
    initStickyBuy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init sliders/accordions when sections are re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
